<template>
    <svg :aria-labelledby="name + '-title'">
        <use :xlink:href="`${$contextPath}${sprite}#icon-${name}`"></use>
    </svg>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
    @Prop() name: string;
    @Prop({ default: '/img/sprite.svg' }) source: string;

    get sprite(): string {
        return (this.$prototype ? '' : '/.resources/rebrush/webresources') + this.source;
    }
}

</script>
